/**
 * Definition of all routes of the application.
 */
export const routes = {
  unhandledError: {
    url: 'serverunhandlederror',
    absoluteUrl: '/serverunhandlederror',
  },
  login: {
    url: 'login',
    absoluteUrl: '/login',
  },
  tenants: {
    url: 'tenants',
    absoluteUrl: '/tenants',
  },
  tenantsCreate: {
    url: 'tenants/create',
    absoluteUrl: '/tenants/create',
  },
  tenantsEdit: {
    url: 'tenants/edit',
    absoluteUrl: '/tenants/edit',
  },
  users: {
    url: 'users',
    absoluteUrl: '/users',
  },
  usersCreate: {
    url: 'users/create',
    absoluteUrl: '/users/create',
  },
  usersEdit: {
    url: 'users/edit',
    absoluteUrl: '/users/edit',
  },
  machines: {
    url: 'machines',
    absoluteUrl: '/machines',
  },
  machinesCreate: {
    url: 'machines/create',
    absoluteUrl: '/machines/create',
  },
  machinesEdit: {
    url: 'machines/edit',
    absoluteUrl: '/machines/edit',
  },
};
